export default class BundleBooked {
	readonly bookings: number;
	readonly pax: number;

	constructor(json: any) {
		this.bookings = json.bookings;
		this.pax = json.pax;
	}
}
